import { createApi } from '@reduxjs/toolkit/dist/query/react';

import { z3xBaseQuery } from 'app/utils/api.utils';
import { IUserCrdLog } from 'app/types/credit.interface';
import { IPageableResponse } from 'app/types/pageable-response';
import { HydraApiResponse } from 'app/types/hydraData';
import { IUserCrdAssign } from 'app/types/user-crd.interface';

interface IGetUserCrdLogArgs {
  userCrd: number
  page: number
  itemsPerPage: number
}

interface IChangePasswordArgs {
  id: number;
}

interface IFinishAllSessionsArgs {
  id: number;
}

interface IUserCrdAssignResponse {
  status: string;
  message: string;
}

export const creditApi = createApi({
  reducerPath: 'creditApi',
  baseQuery: z3xBaseQuery({ type: 'ld+json' }),
  endpoints: (builder) => ({
    getUserCrdLogs: builder.query<IPageableResponse<IUserCrdLog>, IGetUserCrdLogArgs>({
      query: (params) => ({
        url: 'user-crd-logs',
        params: {
          ...params,
          'order[date]': 'desc'
        },
      }),
      transformResponse: (response: HydraApiResponse<IUserCrdLog[]>) => {
        return {
          items: response['hydra:member'],
          totalItems: response['hydra:totalItems']
        };
      }
    }),
    changePassword: builder.mutation<null, IChangePasswordArgs>({
      query: ({ id }) => ({
        url: `/user-crds/${id}/change-password`,
        method: 'POST',
        body: { id }
      }),
    }),
    finishAllSessions: builder.mutation<null, IFinishAllSessionsArgs>({
      query: ({ id }) => ({
        url: `/user-crds/${id}/finish-all-sessions`,
        method: 'POST',
        body: { id }
      }),
    }),
    assignToCurrentUser: builder.mutation<IUserCrdAssignResponse, IUserCrdAssign>({
      query: (body) => ({
        headers: {
          'content-type': 'application/json'
        },
        url: '/user-crds/assign-to-current-user',
        method: 'POST',
        body: JSON.stringify(body)
      })
    })
  })
});

export const {
  useGetUserCrdLogsQuery,
  useLazyGetUserCrdLogsQuery,
  useChangePasswordMutation,
  useFinishAllSessionsMutation,
  useAssignToCurrentUserMutation,
  util: { resetApiState: userCrdLogsResetApiState },
} = creditApi;